<template>
    <svg 
        :width="width" 
        :height="height" 
        viewBox="0 0 4 14" 
        fill="none" 
        preserveAspectRatio="xMidYMid meet"
        xmlns="http://www.w3.org/2000/svg" 
        class="menu-options"
    >
        <path 
            fill-rule="evenodd" 
            clip-rule="evenodd" 
            d="M0.833008 1.77067C0.833008 1.02279 1.43929 0.416504 2.18717 0.416504C2.93506 0.416504 3.54134 1.02279 3.54134 1.77067C3.54134 2.51856 2.93506 3.12484 2.18717 3.12484C1.43929 3.12484 0.833008 2.51856 0.833008 1.77067ZM0.833008 7.18734C0.833008 6.43945 1.43929 5.83317 2.18717 5.83317C2.93506 5.83317 3.54134 6.43945 3.54134 7.18734C3.54134 7.93522 2.93506 8.5415 2.18717 8.5415C1.43929 8.5415 0.833008 7.93522 0.833008 7.18734ZM2.18717 11.2498C1.43929 11.2498 0.833008 11.8561 0.833008 12.604C0.833008 13.3519 1.43929 13.9582 2.18717 13.9582C2.93506 13.9582 3.54134 13.3519 3.54134 12.604C3.54134 11.8561 2.93506 11.2498 2.18717 11.2498Z" 
            :fill="computedColor"
        />
    </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: Number,
      default: 4,
    },
    height: {
      type: Number,
      default: 14,
    },
    color: {
      type: String,
      default: "#8869FD",
    },
    hoverColor: {
      type: String,
      default: "#D4C9FF",
    },
    activeColor: {
      type: String,
      default: "#FBFBFB",
    },
    isHovered: {
      type: Boolean,
      default: false,
    },
    isOpen: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    computedColor() {
      if (this.isOpen) return this.activeColor;
      if (this.isHovered) return this.hoverColor;
      return this.color;
    },
  },
};
</script>